import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { findUniqueConnections } from "../utils/connectorHelpers";
import { createAndSnapViewerObjectToMountingRail } from "../functions/interactiveBoaxelSection";
import { DELETE } from "@inter-ikea-storagetwo/range/dist/constants";
export default class InteractiveBoaxelSectionSystem extends SystemBase {
    constructor(core) {
        super(ComponentIds.HOST_CONNECTIONS_COMPONENT_ID);
        this.core = core;
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = "InteractiveBoaxelSectionSystem";
        this.mandatoryComponents = [COMPONENT_IDS.MOUNTING_RAIL_COMPONENT];
    }
    onAddComponent(_entity, _newComponent) {
        super.onAddComponent(_entity, _newComponent);
        const connection = _newComponent.connections[0];
        createAndSnapViewerObjectToMountingRail(this.core, connection);
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        super.onUpdateComponent(_entity, _oldComponent, _newComponent);
        const { connections, action } = findUniqueConnections(_newComponent.connections, _oldComponent.connections);
        if (!connections || action === DELETE)
            return;
        createAndSnapViewerObjectToMountingRail(this.core, connections[0]);
    }
    onRemoveComponent(_entity, _oldComponent) {
        super.onRemoveComponent(_entity, _oldComponent);
    }
}
